import { Box, Card, Skeleton, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { useIRRScoreCards } from './useIRRScoreCards';

const IRRCard = ({ value, title }: { value: number; title: string }) => {
  const theme = useTheme();
  return (
    <Card
      sx={{
        p: theme.spacing(6),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(2),
        flex: 1,
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: '700' }}>
        {value.toFixed(4)}
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: '400', color: theme.palette.grey[800] }}>
        {title}
      </Typography>
    </Card>
  );
};

export const IRRScoreCards = () => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const { irrScoreCardsData, isIRRScoreCardsDataLoading } = useIRRScoreCards();
  if (!irrScoreCardsData) return;
  if (isIRRScoreCardsDataLoading) {
    return (
      <Box sx={{ display: 'flex', gap: theme.spacing(4), p: theme.spacing(4) }}>
        <Skeleton variant="rectangular" height="150px" sx={{ flex: 1 }} />
        <Skeleton variant="rectangular" height="150px" sx={{ flex: 1 }} />
      </Box>
    );
  }
  return (
    <Box sx={{ display: 'flex', gap: theme.spacing(4), p: theme.spacing(4) }}>
      <IRRCard
        value={irrScoreCardsData.dailyInitialF1Measure}
        title={formatMessage({ id: 'metrics.irrScore.cards.initialF1Measure' })}
      />
      <IRRCard
        value={irrScoreCardsData.dailyCurrentF1Measure}
        title={formatMessage({ id: 'metrics.irrScore.cards.currentF1Measure' })}
      />
    </Box>
  );
};
